import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import {
  addManyFenceResult,
  patchManyFenceResult,
  purgeFenceResult
} from '@app/store/faxe/fence-result/fence-result.actions';
import { FenceResult } from '@app/rest-client/faxe/models/fence-result';
import { sapiensEntityState, SliceState } from '@app/store/faxe/sapiens-entity-state';

export const identifier = (a: FenceResult): string => a.fenceResultGuid;

export const adapter: EntityAdapter<FenceResult> = createEntityAdapter<FenceResult>({
  selectId: identifier
});

export type FenceResultEntityState = sapiensEntityState<FenceResult>;

export const initialState: FenceResultEntityState = adapter.getInitialState({
  meta: {
    sliceState: SliceState.inital,
    isReportable: undefined,
    timestamp: Date.now(),
  }
});

const reducer = createReducer(
  initialState,
  on(addManyFenceResult, (state, { models, sliceState, issuerStack }) => ({
    ...adapter.addMany(models, state),
    meta: {
      ...state.meta,
      sliceState,
      issuerStack,
      timestamp: Date.now(),
    },
  })),
  on(patchManyFenceResult, (state, { models, issuerStack }) => ({
    ...adapter.addMany(models, state),
    meta: {
      ...state.meta,
      issuerStack,
      timestamp: Date.now(),
    },
  })),
  on(purgeFenceResult, (state) => ({
    ...adapter.removeAll(state),
    meta: {
      ...state.meta,
      isReportable: undefined,
      issuerStack: undefined,
      timestamp: Date.now(),
    },
  }))
);

export const fenceResultReducer: (state: (FenceResultEntityState | undefined), action: Action) =>
  sapiensEntityState<FenceResult> = (state: FenceResultEntityState | undefined, action: Action) =>
  reducer(state, action);

// get the selectors
const {
  selectAll
} = adapter.getSelectors();

// select the array of users
export const selectAllFenceResult = selectAll;


